import { useAuth } from "../../authentication/hooks/useAuth";
import { useRoleAccess } from "../../users/hooks/useRoleAccess";
import AdminDashboard from "./AdminDashboardContent";
import CustomerDashboardContent from "./CustomerDashboardContent";
import EmployeeDashboardContent from "./EmployeeDashboardContent";
import DashboardLayout from "./DashboardLayout";
import AuthGuard from "../../authentication/components/AuthGuard";
import { useMemo } from "react";
import { usePageLoadTracking } from "../../../hooks/usePerformanceTracking";
import { useSetPageMeta } from "../../../hooks/usePageMeta";

export default function Dashboard() {
  const { user } = useAuth();
  const permissions = useRoleAccess();

  // Set page metadata
  useSetPageMeta({
    title: 'Dashboard',
    description: 'Overview of your business metrics and activities'
  });

  // Track page load performance
  usePageLoadTracking("dashboard");

  // Memoize the dashboard content rendering
  const content = useMemo(() => {
    if (!user) return null;
    switch (user.role) {
      case "admin":
        return <AdminDashboard user={user} permissions={permissions} />;
      case "manager":
        return <AdminDashboard user={user} permissions={permissions} />;
      case "employee":
        return (
          <EmployeeDashboardContent user={user} permissions={permissions} />
        );
      case "customer":
        return <CustomerDashboardContent user={user} />;
      default:
        return null; // AuthGuard handles unauthorized access
    }
  }, [user, permissions]);

  return (
    <AuthGuard requireRole={["admin", "manager", "employee", "customer"]}>
      {user && (
        <DashboardLayout user={user} permissions={permissions}>
          {content}
        </DashboardLayout>
      )}
    </AuthGuard>
  );
}
